import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_LIST_ITEMS_START, DELETE_LIST_ITEMS_ERROR, DELETE_LIST_ITEMS_SUCCESS, GET_LIST_ITEMS_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/list-items/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_LIST_ITEMS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_LIST_ITEMS_ERROR, error });
  } finally {
    yield put({ type: GET_LIST_ITEMS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_list_items() {
  yield takeLatest(DELETE_LIST_ITEMS_START, del);
}


